import React, { Component } from 'react';
import withStyles from '@mui/styles/withStyles';
import Grid from '../../components/layout/Grid';
import Separator from '../../components/layout/Separator';
import Typography from '../../components/form/Typography';
import Inline from '../../components/layout/Inline';
import Checkbox from '../../components/form/Checkbox';
import RadioGroup from '../../components/form/RadioGroup';
import TextField from '../../components/form/TextField';
import Select from '../../components/form/Select';
import SearchIcon from '../../components/icon/SearchIcon';
import { validationHelper } from '../../utils/validation';
import UploadField from '../../components/form/UploadField';
import SearchWithButton from '../../components/form/SearchWithButton';
import NotesReadOnly from '../../components/form/NotesReadOnly';
import SortByDropdown from '../../components/form/SortByDropdown';
import UploadFile, { IconUploadFile } from '../../components/form/FileUpload';
import StaffAutoComplete from '../../components/form/StaffAutoComplete';
import ColumnLayout from '../../components/layout/ColumnLayout';
import HtmlEditor from '../../components/form/HtmlEditor';
import createForm from '../../utils/createForm';
import AddressAutocomplete from '../../components/form/AddressAutocomplete';
import ContactLookup from '../../components/contact/ContactLookup';
import AutoComplete from '../../components/form/AutoComplete';

class FormElementStyling extends Component {
    state = {
        form: createForm(this, { Description: null })
    };

    render() {
        return (
            <ColumnLayout>
                {this.renderFormElements()}
                {this.renderComplexElements()}
            </ColumnLayout>
        );
    }

    renderFormElements() {
        return (
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Typography variant="h5">Checkbox</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Inline>
                        <Checkbox label="Sample Checkbox" />
                        <Checkbox label="Checked" checked helperText="I'm checked!" />
                        <Checkbox label="Disabled" checked disabled />
                        <Checkbox label="Error" validationResult={{ valid: false }} />
                    </Inline>
                </Grid>

                <Grid item xs={12}>
                    <Typography variant="h5">Radio</Typography>
                </Grid>
                <Grid item xs={12}>
                    <RadioGroup
                        options={[
                            { label: 'radio item 1', value: 'item1' },
                            { label: 'radio item 1', value: 'item2' },
                            { label: 'radio item 3', value: 'item3' }
                        ]}
                        value="item2"
                        label="My Radio Group"
                    />
                    <RadioGroup
                        options={[
                            { label: 'radio item 1', value: 'item1' },
                            { label: 'radio item 1', value: 'item2' },
                            { label: 'radio item 3', value: 'item3' }
                        ]}
                        value="item2"
                        label="Disabled radio group"
                        disabled
                        helperText="I'm disabled :("
                    />
                    <RadioGroup
                        options={[
                            { label: 'radio item 1', value: 'item1' },
                            { label: 'radio item 1', value: 'item2' },
                            { label: 'radio item 3', value: 'item3' }
                        ]}
                        value="item2"
                        label="Error radio group"
                        validationResult={{ valid: false }}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Typography variant="h5">TextField</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Inline>
                        <TextField label="Label shrink" placeholder="placeholder" value="some text" />
                        <TextField label="Type Here" placeholder="placeholder" helperText="Type there!" />
                        <TextField label="Disabled" value="This text is disabled" disabled />
                        <TextField label="Readonly" value="This text cannot be changed" readOnly />
                        <TextField label="Multiline" value="This text is on multiple lines.
                        Cheers" multiline />
                    </Inline>
                    <Inline>
                        <TextField
                            label="Optional validation"
                            value="Turkey"
                            validationResult={validationHelper.optional('This is different')}
                        />

                        <TextField
                            label="Suggested validation"
                            value="Mince"
                            validationResult={validationHelper.suggested('This is a warning')}
                        />

                        <TextField
                            label="Required validation"
                            value="Batman"
                            multiline
                            validationResult={validationHelper.required('This is an error')}
                        />
                    </Inline>
                </Grid>

                <Grid item xs={12}>
                    <Typography variant="h5">TextField with adornments</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Inline>
                        <TextField label="Search" placeholder="Enter a value" icon={<SearchIcon />} />

                        <TextField label="Search" placeholder="Enter a value" icon={<SearchIcon />} loading />

                    </Inline>
                </Grid>

                <Grid item xs={12}>
                    <Typography variant="h5">Select</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Inline>
                        <Select
                            fullWidth={false}
                            label="Select the thing"
                            options={[
                                { label: 'item 1', value: '10' },
                                { label: 'item 2', value: '20', disabled: true },
                                { label: 'item 3', value: '30' },
                                {
                                    label: 'Some group', options: [
                                        { label: 'subitem 1', value: '33' }
                                    ]
                                },
                                { label: 'item 4', value: '40' }
                            ]}
                            helperText="I'm the helperText!"
                        />
                        <Select
                            fullWidth={false}
                            label="Disabled"
                            disabled
                            options={[
                                { label: 'item 1', value: '15' },
                                { label: 'item 2', value: '30' }
                            ]}
                        />
                        <Select
                            fullWidth={false}
                            label="Error"
                            placeholder="Pick any option, it's wrong"
                            options={[
                                { label: 'item 1', value: '15' },
                                { label: 'item 2', value: '30' }
                            ]}
                            validationResult={{ valid: false }}
                        />
                    </Inline>
                </Grid>
            </Grid>
        );
    }

    renderComplexElements() {
        const substitutionFields = {
            '[[SomeData]]': 'BOOM', '[[MissingData]]': ''
        };
        const { form } = this.state;
        return (
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Typography variant="h4">Text editor</Typography>
                    <HtmlEditor
                        label="Body"
                        placeholder="Enter body of note, or choose a new template..."
                        shortcodes={substitutionFields}
                        required
                        form={form}
                        name="Description"
                    />
                </Grid>

                <Grid item>
                    <Separator />
                    <br />
                </Grid>

                <Grid item xs={6}>
                    <Typography variant="h4">Attach / Upload Field</Typography>
                    <UploadField />
                </Grid>
                <Grid item xs={6}>
                    <Typography variant="h4">Upload File</Typography>
                    <Inline>
                        <div>
                            <UploadFile />
                            {'<'}UploadFile {'/>'}
                        </div>
                        {' '}
                        <div>
                            <IconUploadFile />
                            {'<'}UploadFile useIcon {'/>'}
                        </div>
                    </Inline>
                </Grid>

                <Grid item>
                    <Typography variant="h4">Search Field with a Button</Typography>
                    <SearchWithButton placeholder="Search with Button..." />
                </Grid>

                <Grid item>
                    <Separator />
                    <br />
                </Grid>
                <Grid item>
                    <Typography variant="h4">Autocomplete</Typography>
                    <AutoComplete label="Custom list of food" options={[
                        { label: 'HotDog', value: 'misc' },
                        { label: 'Burger', value: 'cow' },
                        { label: 'Sausage', value: 'pig' },
                        { label: 'Chicken', value: 'chicken' }
                    ]} />
                    <pre>{`<AutoComplete options />`}</pre>
                    <StaffAutoComplete label="Find User" />
                    <pre>{`<StaffAutoComplete clearOnSelect="false" />`}</pre>
                    <AddressAutocomplete label="Find Address" />
                    <pre>{`<AddressAutocomplete componentFields />`}</pre>
                    <ContactLookup label="Find Contact" />
                    <pre>{`<ContactLookup />`}</pre>
                </Grid>

                <Grid item>
                    <Separator />
                    <br />
                </Grid>
                <Grid item>
                    <Typography variant="h4">Sort By</Typography>
                    <SortByDropdown label="sort by" />
                    <SortByDropdown label="Brand:" variant="brand" />
                </Grid>

                <Grid item>
                    <Separator />
                    <br />
                </Grid>

                <Grid item>
                    <h4>Notes history</h4>
                    <p>Tag = NotesReadOnly. Props = name & form, or value</p>
                    <NotesReadOnly
                        name={false}
                        form={false}
                        value={'I am some notes, hear me roar!\nRoar!\n\nHow good was that?'}
                    />
                </Grid>
            </Grid>
        );
    }
}

export default withStyles({})(FormElementStyling);
